
import './Testimonial.css'
import CardTestimonial from '../Components/CardTestimonial.jsx'

function Testimonial(props) {
    return (
        <>
            <section class="testimonial-section">
                <div class="container mx-auto">
                    <CardTestimonial/>
                </div>        
            </section>
        </>
    );
}

export default Testimonial;